import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import EditorialMarquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import BeforeAfter from "@/components/BeforeAfter";
import About from "@/components/About";
import Reviews from "@/components/Reviews";
import AgentStrip from "@/components/AgentStrip";
import QuoteSection from "@/components/QuoteSection";
import Footer from "@/components/Footer";
import StickyCallBar from "@/components/StickyCallBar";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-coal text-bone font-sans antialiased" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <EditorialMarquee />
        <Manifesto />
        <Services />
        <BeforeAfter />
        <About />
        <Reviews />
        <AgentStrip />
        <QuoteSection />
      </main>
      <Footer />
      <StickyCallBar />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid #222222",
            color: "#F5F5F5",
            borderRadius: "0px",
          },
        }}
      />
    </div>
  );
}
